import type { AccessTokenProvider } from '@empathyco/playboard-core-domain'
import type { Store } from 'vuex'
import { interfaces } from 'inversify'
import { TYPES } from '../config/inversify.types'
import { AUTH_CONSTS } from '../store/auth/auth.consts'
import Context = interfaces.Context

/**
 * Function to inject a {@link AccessTokenProvider} using InversifyJS. The provider injected takes
 * the token from the Vuex store, from the `'epb-auth'` module.
 *
 * @param context - The InversifyJS context, which includes the container. This is used to get the
 * Vuex Store.
 *
 * @remarks This function needs the InversifyJS context, then it needs to be bound to container
 * using `toDynamicValue`:
 * `CONTAINER.bind(TYPES.AccessTokenProvider).toDynamicValue(storeTokenProvider);`.
 */
export function getStoreTokenProvider({ container }: Context): AccessTokenProvider {
  return () => {
    const store = container.get<Store<any>>(TYPES.Store)
    const token = store.getters[`${AUTH_CONSTS.moduleName}/${AUTH_CONSTS.getters.token}`]
    return Promise.resolve(token)
  }
}
